import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
@Component({
  selector: 'loyaltic-tournament-list',
  templateUrl: './tournament-list.component.html',
  styleUrls: ['./tournament-list.component.scss']
})
export class TournamentListComponent implements OnInit {
  @ViewChild('deleteTournament', { static: false }) deleteTournamentRef: any;

  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  userId = '';
  deleteTournamentId = '';
  tournaments: any[] = [];

  public modalRef: BsModalRef;


  constructor(private readonly router: Router, 
    private readonly toastr: ToastrService,
    private gaService: GaService,
    private readonly translate: TranslateService,
    private modalService: BsModalService,
    private readonly coreService: CoreService, 
    private readonly authService: AuthService ) { }

  ngOnInit() {
    this.userId = this.authService.getUserId();
    this.getTournaments();
  }
  createTournament() {
    this.router.navigate(['/create-tournament']);
  }

  getTournaments() {
    let currentDate = new Date();
    this.coreService.getTournaments(this.userId).then((response:any) => {
      this.tournaments = response.result;
      this.tournaments.map((tournament:any) => {

        let startDate = new Date(tournament.startDate);
        let endDate = new Date(tournament.endDate);

        if (startDate > currentDate || endDate < currentDate) {
          tournament.isActive = false;
        } else {
          tournament.isActive = true;
        }
      })
    })
  }

  play(code, tournamentId, adminId) {
    localStorage.setItem('tournamentAdminId', adminId);
    localStorage.setItem('tournamentid', tournamentId);
    this.coreService.play(this.userId, code).then((response:any) => {
      this.gaService.emitEvent('gameplays', 'Register Screen');
      window.open(response.result.gameurl, '_self')
    })
  }

  deleteTournamentPopup(tournamentId) {
    this.deleteTournamentId = tournamentId;
    this.modalRef = this.modalService.show(this.deleteTournamentRef, this.popupConfig);
  }

  delete() {
    this.coreService.deleteTournament(this.deleteTournamentId).then((response:any) => {
      this.toastr.success(this.translate.instant('tourament-deleted'), '');
      this.modalRef.hide();
      this.getTournaments();
    })
  }

  close() {
    this.modalRef.hide();
  }

  goToRanking(tournamentId, adminId, tournamentName, uniqueCode, isActive) {
    localStorage.setItem('tournamentAdminId', adminId);
    localStorage.setItem('tournamentid', tournamentId);
    localStorage.setItem('tournamentName', tournamentName);
    localStorage.setItem('uniqueCode', uniqueCode);
    localStorage.setItem('isActive', isActive);
    this.router.navigate(['/ranking']);
  }
}
